export default "__VITE_ASSET__CuKKM28X__"